<template>
  <section class="homepage-section">
    <TwinColorTitle> Trips <em>we’ve taken</em> </TwinColorTitle>

    <div class="boxes">
      <div class="box">
        <em>80+</em>
        <span>destinations</span>
      </div>
      <div class="box">
        <em>1,000+</em>
        <span>TourHeroes</span>
      </div>
      <div class="box">
        <em>10,000+</em>
        <span>travelers</span>
      </div>
      <div class="box">
        <em>100,000+</em>
        <span>days traveled</span>
      </div>
    </div>
  </section>
</template>

<script setup>
import TwinColorTitle from '@/components/Theme2/TwinColorTitle.vue'
</script>

<style lang="scss" scoped>
section.homepage-section {
  align-items: center;
  border-radius: 16px;
  padding-block: 64px 184px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.25) 60%, #fff 100%),
    url(app/assets/images/home/sea_background.jpeg) center / cover no-repeat;
  gap: 40px;

  @include mobile {
    padding-bottom: 32px;
    margin-bottom: 0;
  }

  .boxes {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;
    padding: 0 16px;

    @media (min-width: $breakpoint-m) and (max-width: 1442px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include mobile {
      width: 100%;
      grid-template-columns: 1fr;
    }
  }

  .box {
    @include flex-column(16px);
    padding: 24px;
    aspect-ratio: 212/122;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.4);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(15px);
    text-align: center;

    @include mobile {
      aspect-ratio: auto;
    }
  }

  .box em {
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    color: $green-400;
    margin-top: auto;
  }

  .box span {
    font-size: 20px;
    font-weight: 600;
    line-height: 120%;
    color: $grey-300;
    margin-bottom: auto;
  }
}
</style>
